"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BulbSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M16.05,2A9.77,9.77,0,0,0,6.2,11.46,9.31,9.31,0,0,0,11,19.6V23a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V19.61a9.19,9.19,0,0,0,4.8-8.15A9.61,9.61,0,0,0,16.05,2Z"/><rect x="11" y="25" width="10" height="2" rx="1"/><rect x="12" y="28" width="8" height="2" rx="1"/>';
var BulbSVG = function BulbSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.BulbSVG = BulbSVG;
BulbSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(BulbSVG);
exports.default = _default;